import http from "../jslibs/axios/http";

export const getStageList = (data) => http.get("/v1/cms/PunchStage", data);
export const deleteStage = (id) => http.delete(`/v1/cms/PunchStage/${id}`);
export const addStage = (data) => http.post(`/v1/cms/PunchStage`, data);
export const editStage = (id, data) => http.put(`/v1/cms/PunchStage/${id}`, data);
export const getStage = (id) => http.get(`/v1/cms/PunchStage/${id}`);

export const getTagList = (data) => http.get("/v1/cms/PunchLabel", data);
export const deleteTag = (id) => http.delete(`/v1/cms/PunchLabel/${id}`);
export const addTag = (data) => http.post(`/v1/cms/PunchLabel`, data);
export const editTag = (id, data) => http.put(`/v1/cms/PunchLabel/${id}`, data);
export const getTag = (id) => http.get(`/v1/cms/PunchLabel/${id}`);

export const getGroupList = (data) => http.get("/v1/cms/PunchGrouping", data);
export const deleteGroup = (id) => http.delete(`/v1/cms/PunchGrouping/${id}`);
export const addGroup = (data) => http.post(`/v1/cms/PunchGrouping`, data);
export const editGroup = (id, data) => http.put(`/v1/cms/PunchGrouping/${id}`, data);
export const getGroup = (id) => http.get(`/v1/cms/PunchGrouping${id}`);

export const getRelationUserList = (data) => http.get("/v1/cms/RelationUser", data);
export const deleteRelation = (data) => http.post("/v1/cms/RelationUserBatchDelete", data);
export const relationUser = (data) => http.post("/v1/cms/RelationUser", data);
